import Carousel, {
  CarouselTemplateSpec,
} from 'components/common/carousels/Carousel';

export default class DefaultCarousel extends Carousel {
  override set imageKey(key: CarouselTemplateSpec['imageKey']) {
    this._imageKey = key;
    this.updateCarousel();
  }

  override set expandedImageKey(key: CarouselTemplateSpec['expandedImageKey']) {
    this._expandedImageKey = key;
    this.updateCarousel();
  }
}
